<template>
    <div class="frame-wrap">
        <div class="frame-main">
            <div class="el-icon-close" @click="closeBtn" style="cursor:pointer;"></div>
            <div class="frame-main-con" :style="{height:height}">
                <p class="frame-title">{{$t('business.demandDetails')}}</p>
                <div class="frame-top">
                    <img :src="$imgUrl + userInfo.avatar" alt="">
                    <div class="frame-infor">
                        <p class="frame-infor-title">{{userInfo.name}}
                            <span v-if="langSet == 'zh' || userInfo.en_dutiesName.length == 0">{{userInfo.dutiesName}}</span>
                            <span v-if="langSet == 'en' && userInfo.en_dutiesName.length > 0">{{userInfo.en_dutiesName}}</span>
                        </p>
                        <p>{{userInfo.company}}</p>
                        <p>{{userInfo.mobile}}</p>
                    </div>
                    <img src="../../../assets/bianji.png" class="frame-edit" alt="" @click="editBtn">
                </div>
                <ul class="frame-list">
                    <li>
                        <p class="frame-list-title">{{$t('business.businessMode')}}<span>{{$t('business.multi')}}</span></p>
                        <div class="frame-label">
                            <p class="active" v-if="userInfo.type[0] > 0" >{{$t('business.trade')}}</p>
                            <p class="active" v-if="userInfo.type[1] > 0" >{{$t('business.internationalTrade')}}</p>
                        </div>
                    </li>
                    <li v-if="userInfo.label != null && userInfo.label.length > 0">
                        <p class="frame-list-title">{{$t('business.demandTag')}}</p>
                        <div class="label-list frame-label">
                            <p class="active" v-for="(item, index) in userInfo.label" :key="index">
                                <span v-if="langSet == 'zh' || item.en_name.length == 0">{{item.name}} </span>
                                <span v-if="langSet == 'en' && item.en_name.length > 0">{{item.en_name}} </span>
                            </p>
                        </div>
                    </li>
                    <li v-if="userInfo.imgs != undefined && userInfo.imgs.length > 0">
                        <p class="frame-list-title">{{$t('business.demandPhoto')}}</p>
                        <div class="frame-upimg">
                            <div class="upimg" v-for="(item, index) in userInfo.imgs" :key="index">
                                <img :src="$imgUrl + item.url" alt="">
                            </div>
                        </div>
                    </li>
                    <li v-if="userInfo.description != undefined && userInfo.description.length > 0 || userInfo.en_description.length > 0">
                        <p class="frame-list-title">{{$t('business.demandMessage')}}</p>
                        <div v-if="langSet == 'zh' || userInfo.en_description.length == 0" class="label-list frame-label">{{userInfo.description}}</div>
                        <div v-if="langSet == 'en' && userInfo.en_description.length > 0" class="label-list frame-label">{{userInfo.en_description}}</div>
                    </li>
                </ul>
                <div class="frame-answer" v-if="replyList.length > 0">
                    <p class="frame-answer-title">{{$t('business.repayList')}}</p>
                    <ul class="frame-answer-list">
                        <li v-for="(item, index) in replyList" :key="index">
                            <div class="frame-answer-top">
                                <img :src="$imgUrl + item.avatar" alt="">
                                <div class="text">
                                    <p>{{item.nickname}}<span>{{item.dutiesName}}</span></p>
                                    <p>{{item.companyName}}</p>
                                </div>
                            </div>
                            <div class="frame-answer-content">
                               {{$t('business.replyMessage')}}：{{item.reply}}
                            </div>
                            <div class="concatIcon" @click="showContact(item.mobile,item.email)">
                                <img class="concatIconImage" src="../../../assets/concat.png" alt="">
                                <p>{{$t('business.liaison')}}</p>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="frame-answer-btn" style="padding-bottom:20px;">
                    <p class="frame-del-btn" @click="deleteRequest(userInfo.id)">{{$t('business.deleteRequest')}}</p>
                    <p v-if="state == 1" @click="retrieveRequest(0,userInfo.id)">{{$t('business.retrieveRequest')}}</p>
                    <p v-if="state == 0" @click="retrieveRequest(1,userInfo.id)">{{$t('business.publish')}}</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { getNeedDetail, getNeedLabel, needReply, editState, delNeed, replyList} from "@/api/api";
export default {
    props: [ 'detailsId' ],
    data() {
        return {
            tradeChoose:[
                {
                    title: '中国国内贸易',
                    state: true
                },
                {
                    title: '国际贸易',
                    state: false
                }
            ],
            demandCurrent: 0,
            labelList:[],
            height: '',
            chinese: '',
            en: '',
            userInfo:{
                type:[],
                label: [],
                imgs: [],
                description: '',
                en_dutiesName: [],
                en_description: '',
            },
            memberid: '',
            langSet: '',
            state: '',
            replyList:[]
        }
    },
    created() {
    },
    mounted() {
        this.langSet = localStorage.getItem('languageSet') || 'zh';
        this.memberid = localStorage.getItem('memberid');
        this.placeholder = this.$t('bussindess.inputContents');
        this.getLabel();
        this.setHeight();
        this.getData(this.detailsId);
        this.getReplyList(this.detailsId);
    },
    computed:{

    },
    methods: {
        closeBtn(){
            this.$emit('close-details', false)
        },
        editBtn(){
            this.$router.push({name: 'dataEdit'});
        },
        setHeight(){
            this.height = window.innerHeight  - 250 + 'px';
        },
        getData(id){
            let data = this.$qs.stringify({
                memberid: this.memberid,
                id
            })
            getNeedDetail(data).then(res=>{
                //console.log(res.data.rst)
                if(res.data.errno == 0){
                    this.userInfo = res.data.rst;
                    this.state = res.data.rst.state;
                }
            }).catch(err=>{
                console.log(err)
            })
        },
        getReplyList(id){
            let data = this.$qs.stringify({
                needid: id,
            })
            replyList(data).then(res=>{
                //console.log(res)
                this.replyList = res.data.rst
            }).catch(err=>{
                console.log(err)
            })
        },
        changeTrade(index){
           let item = this.tradeChoose[index];
           item.state = ! item.state;
        },
        demandTrade(index){
            this.demandCurrent = index;
        },
        demandLabel(index){
            let item = this.labelList[index];
            item.state = ! item.state;
        },
        getLabel(){
            let data = this.$qs.stringify({
                memberid: this.memberid,
            })
            getNeedLabel(data).then(res=>{
                //console.log(res.data)
                if(res.data.errno == 0){
                    res.data.rst.forEach(item => {
                        item.state = false;
                    })
                    this.labelList = res.data.rst;
                }   
            }).catch(err=>{
                console.log(err)
            })
        },
        showContact(mobile, email){
            let tipsTitle,
                tipsCon,
                tipsConcel,
                tipsComfirm;
            let confirmText; 
            const confirmEText = ["Mobile："+ mobile,  "Email：" + email];
            if(this.langSet == 'zh'){
                confirmText = ["手机号："+ mobile,  "邮箱：" + email];
            }else{
                confirmText = ["Mobile："+ mobile,  "Email：" + email];
            }
            const newDatas = [];
            const h = this.$createElement;
            for (const i in confirmText) {
                newDatas.push(h('p', null, confirmText[i]))
            }
            if(this.langSet == 'zh'){
                tipsTitle = "联系方式";
                tipsCon = h('div', null, newDatas);
                tipsComfirm ="确定";
            }else{
                tipsTitle = "Contact";
                tipsCon = h('div', null, newDatas);
                tipsComfirm ="Confirm";
            }
            this.$confirm(tipsCon, tipsTitle, {
                confirmButtonText: tipsComfirm,
                showCancelButton:false,
            }).then((res) => {
                console.log(res);
            })
        },
        retrieveRequest(state,id){
            //console.log(state)
            if(state == 0){
                this.state = 1;
                let tipsTitle,
                    tipsCon,
                    tipsConcel,
                    tipsComfirm;
                if(this.langSet == 'zh'){
                    tipsTitle = "提示";
                    tipsCon = "确定要暂停发布吗?";
                    tipsConcel = "取消";
                    tipsComfirm ="确定";
                }else{
                    tipsTitle = "Tips";
                    tipsCon = "Are you sure you want to pause publishing?";
                    tipsConcel = "Cancel";
                    tipsComfirm ="Confirm";
                }
                this.$confirm(tipsCon, tipsTitle, {
                    confirmButtonText: tipsComfirm,
                    cancelButtonText: tipsConcel,
                }).then((res) => {
                    //console.log(res);
                    let data = this.$qs.stringify({
                        memberid: this.memberid,
                        id,
                        state
                    })
                    this.editStateUp(data);
                }).catch((err) => {
                    console.log(err)
                     return false;
                });
            }else{
                this.state = 0;
                let tipsTitle,
                    tipsCon,
                    tipsConcel,
                    tipsComfirm;
                if(this.langSet == 'zh'){
                    tipsTitle = "提示";
                    tipsCon = "确定要发布吗?";
                    tipsConcel = "取消";
                    tipsComfirm ="确定";
                }else{
                    tipsTitle = "Tips";
                    tipsCon = "Are you sure you want to publish it?";
                    tipsConcel = "Cancel";
                    tipsComfirm ="Confirm";
                }
                this.$confirm(tipsCon, tipsTitle, {
                    confirmButtonText: tipsComfirm,
                    cancelButtonText: tipsConcel,
                }).then((res) => {
                    //console.log(res);
                    let data = this.$qs.stringify({
                        memberid: this.memberid,
                        id,
                        state
                    })
                    this.editStateUp(data);
                }).catch((err) => {
                    return false;
                });
            }
        },
        editStateUp(data) {
            editState(data).then(res=>{
                //console.log(res);
                location.reload();
            }).catch(err=>{
                console.log(err)
            })  
        },
        deleteRequest(id){
            let tipsTitle,
                tipsCon,
                tipsConcel,
                tipsComfirm;
            if(this.langSet == 'zh'){
                tipsTitle = "提示";
                tipsCon = "确定要删除需求吗?";
                tipsConcel = "取消";
                tipsComfirm ="确定";
            }else{
                tipsTitle = "Tips";
                tipsCon = "Are you sure you want to delete the requirement?";
                tipsConcel = "Cancel";
                tipsComfirm ="Confirm";
            }
            this.$confirm(tipsCon, tipsTitle, {
                confirmButtonText: tipsComfirm,
                cancelButtonText: tipsConcel,
            }).then(() => {
                let data = this.$qs.stringify({
                    memberid: this.memberid,
                    id,
                })
                delNeed(data).then(res=>{
                    //console.log(res);
                    location.reload();
                }).catch(err=>{
                    console.log(err)
                })
            }).catch(() => {       
            });
        }
    },
    watch: {
        $route (to, from) {
            this.$router.go(0)
        }
    }
}
</script>

<style lang="scss">
.frame-answer{border-top:1px solid #E0E0E0;}
.frame-answer .frame-answer-title{font-size:20px;color: #000;line-height:28px;padding:19px 0 15px;}
.frame-answer-list{display: flex;justify-content: space-between;flex-wrap: wrap;}
.frame-answer-list li{width: 49%;height: 146px;background: #ECE9EA;border-radius: 5px;margin-bottom: 20px;}
.frame-answer-btn{display: flex;justify-content: center;}
.frame-answer-btn p{width:140px;height:32px;background:rgba(222,110,98,1);border-radius:5px;color: #fff;text-align: center;line-height: 34px;font-size:15px;border:1px solid rgba(222,110,98,1);cursor: pointer;}
.frame-answer-btn .frame-del-btn{color: #E06D5F;background: #fff;margin-right: 20px;}
.frame-wait p{font-size:18px;color:rgba(214,114,108,1);line-height:25px;text-align: center;}
.frame-wait div{width:375px;height:62px;background:rgba(214,114,108,1);text-align: center;font-size:16px;color:rgba(255,255,255,1);line-height:20px;padding: 0 80px;box-sizing: border-box;display: flex;align-items: center;margin: 15px auto 0;}
.frame-wrap .frame-top .frame-infor .frame-infor-title span{font-size: 14px;color: #666;}
.frame-main{
    overflow-y: scroll;
    .message-top{
        display: flex;
        color: #666;
        font-size: 20px;
        line-height:28px;
        justify-content: space-between;
    }
    .message-top .el-icon-circle-close{
        font-size: 26px;
    }
    .message-info{
        padding: 25px;
        background:rgba(244,244,244,1);
        border-radius:16px;
        .frame-top{
            background:rgba(255,255,255,1);
            box-shadow:0px 2px 4px 0px rgba(0,0,0,0.1);
            border-radius:10px;
        }
        .message-content{
            color: #666;
            padding: 18px 0;
            line-height:28px;
        }
        .message-img{
            display: flex;
            img{
                width:120px;
                height:120px;
                margin-right: 20px;
            }
        }
    }
    .reply-message{
        font-size: 20px;
        color: #666;
        line-height:28px;
        padding: 33px 0 4px;
        position: relative;
        .el-textarea__inner{
            height:178px;
            font-family: "PingFang SC","Helvetica Neue",Helvetica,"Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
        }
        .tips{
            position: absolute;
            bottom: 5px;
            right: 7px;
            font-size:16px;
            color: #878787;
            line-height:22px;
        }
    }
    .messagebtn{
        width:133px;
        height:40px;
        color: #fff;
        font-size: 20px;
        text-align: center;
        line-height: 40px;
        margin: 20px auto 0;
        cursor: pointer;
        background:rgba(186,69,64,1);
    }
}
.frame-answer-list{
    li{
        padding: 20px;
        position: relative;
        box-sizing: border-box;
        .frame-answer-top{
            display: flex;
            align-items: center;
            margin-bottom: 10px;
            img{
                width: 50px;
                height: 50px;
                border-radius: 100%;
                margin-right: 10px;
            }
            .text p{
                line-height: 20px;
                span{
                    color: #666;
                    font-size: 14px;
                    margin-left: 5px;
                }
            }
        }
        .concatIcon{
            width: 45px;
            position: absolute;
            right: 5px;
            top: 5px;
            font-size: 13px;
            cursor: pointer;
            color: #DA7068;
            text-align: center;
            img{width: 100%;}
        }
    }
}
@media only screen and (max-width: 767px){
    .el-message-box {
        width: 60% !important;
    }
    .frame-wrap{
        .frame-main{
            width: 80%;
            height: 70%;
            padding: 0.2rem;
            border-radius: 10px;
        }
        .frame-title{
            font-size: 20px;
        }
        .frame-top{
            width: 100%;
            margin: 0.2rem 0 0;
            padding: 0.2rem 0.5rem 0.2rem 0.2rem;
        }
    }
    .frame-main-con{
        padding: 0 0.2rem;
    }
    .frame-wrap .frame-top .frame-infor .frame-infor-title{font-size: 16px;}
    .frame-list li{padding: 0.18rem 0;}
    .frame-list li .frame-list-title{font-size: 16px;padding-bottom: 0;}
    .frame-label{font-size: 14px;}
    .frame-label p{margin: 0.2rem 0.2rem 0 0;font-size: 14px;}
    .frame-answer-list li{width: 100%;padding: 0.2rem;font-size: 14px;}
    .frame-answer .frame-answer-title{font-size: 16px;padding: 0.2rem 0;}
}
</style>